import { v4 as uuidv4 } from "uuid";
import { useTranslation, Trans } from "react-i18next";
import { useState } from "react";
import {
  getAllPrimaryBeneficiaryFromParties,
  getAllContingentBeneficiaryFromParties,
  isFlagEnabled,
} from "js/utilities";
import { getNameWithPercentageSplit } from "js/formatting";
import ContactUsDialog from "components/ModalDialogs/ContactUsDialog";
import CardWithFields from "components/General/CardWithFields";
import CardDisclaimerBase from "components/General/CardDisclaimerBase";

export default function DeathBenefitCard({ data, deathBenefit }) {
  const { t } = useTranslation();
  const uuid = uuidv4();

  const primaryBeneficiaries = getAllPrimaryBeneficiaryFromParties(
    data.parties
  );
  const contingentBeneficiaries = getAllContingentBeneficiaryFromParties(
    data.parties
  );

  const [contactUsDialogState, setContactUsDialogState] = useState(false);
  const isPolicyHasBeneficiary = () => {
    return (
      primaryBeneficiaries?.length > 0 || contingentBeneficiaries?.length > 0
    );
  };

  return (
    <CardWithFields
      additionalContent={
        <>
          <div>
            <div
              id={`${uuid}-panel`}
              className="px-4 pb-4 overflow-hidden h-20 mt-4 md:h-auto md:mt-0 xl:px-6 xl:pb-6 overflow-y-auto"
            >
              {/* <!-- Beneficiary(s) Details --> */}
              <div className="grid grid-cols-2 gap-4 xl:gap-6">
                {primaryBeneficiaries?.length > 0 && (
                  <div>
                    <div className="text-xs text-theme-text-tertiary">
                      {t(
                        "CustomerPolicyDetails-annuity-death-benefit-primary-beneficiarys"
                      )}
                    </div>
                    {primaryBeneficiaries?.map((primaryBeneficiary, idx) => {
                      return (
                        <Trans
                          i18nKey={getNameWithPercentageSplit(
                            primaryBeneficiary?.person,
                            primaryBeneficiary?.splitPercent,
                            primaryBeneficiary?.sharedEquallyFlag,
                            primaryBeneficiaries.length
                          )}
                          components={{
                            div1: (
                              <div className="text-sm text-theme-text-secondary font-semibold whitespace-nowrap" />
                            ),
                            div2: <span className="text-theme-text-tertiary" />,
                          }}
                        />
                      );
                    })}
                  </div>
                )}

                {contingentBeneficiaries?.length > 0 && (
                  <div>
                    <div className="text-xs text-theme-text-tertiary">
                      {t(
                        "CustomerPolicyDetails-annuity-death-benefit-primary-contingent"
                      )}
                    </div>
                    {contingentBeneficiaries?.map((contingent, idx) => {
                      return (
                        <Trans
                          i18nKey={getNameWithPercentageSplit(
                            contingent?.person,
                            contingent?.splitPercent,
                            contingent?.sharedEquallyFlag,
                            contingentBeneficiaries.length
                          )}
                          components={{
                            div1: (
                              <div className="text-sm text-theme-text-secondary font-semibold whitespace-nowrap" />
                            ),
                            div2: <span className="text-theme-text-tertiary" />,
                          }}
                        />
                      );
                    })}
                  </div>
                )}
              </div>
            </div>
          </div>

          <CardDisclaimerBase
            disclaimer={
              <Trans
                i18nKey={
                  isPolicyHasBeneficiary()
                    ? "CustomerPolicyDetails-beneficiary-disclaimer"
                    : "CustomerPolicyDetails-no-beneficiary-disclaimer"
                }
                components={{
                  button1: (
                    <button
                      className="ui-btn-hyperlink font-semibold"
                      onClick={() => setContactUsDialogState(true)}
                    />
                  ),
                }}
              />
            }
          />
          <ContactUsDialog
            dialogState={contactUsDialogState}
            setDialogState={setContactUsDialogState}
          />
        </>
      }
      ariaLabel={"CustomerPolicyDetails-annuity-death-benefit-aria-label"}
      cardTitle={t("CustomerPolicyDetails-annuity-death-benefit-card-title")}
      cardFields={[]}
    />
  );
}
